import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SortByIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M11.398 23.7138L6.26087 18.0777C5.91304 17.7255 5.91304 17.109 6.26087 16.7568C6.58194 16.3752 7.14381 16.3752 7.46488 16.7568L11.9866 21.7177L16.5351 16.7568C16.8562 16.3752 17.4181 16.3752 17.7391 16.7568C18.087 17.109 18.087 17.7255 17.7391 18.0777L12.602 23.7138C12.2809 24.0954 11.7191 24.0954 11.398 23.7138Z"
            fill="currentColor"
         />
         <path
            d="M12.602 0.286206L17.7391 5.92226C18.087 6.27451 18.087 6.89095 17.7391 7.24321C17.4181 7.62481 16.8562 7.62481 16.5351 7.24321L12.0134 2.28231L7.46488 7.24321C7.14381 7.62481 6.58194 7.62481 6.26087 7.24321C5.91304 6.89095 5.91304 6.27451 6.26087 5.92226L11.398 0.286206C11.7191 -0.0954019 12.2809 -0.0954019 12.602 0.286206Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SortByIcon
